<template>
  <div class="mod-progress">
    <div class="box-chests">
      <div class="line">
      </div>
      <div v-for="(item, index) in list"
           :key="index"
           class="item">
        <div class="ico"
             :class="{[item.ico]: true, disabled: count < item.num}"
             @click="tapReceive(index)">
        </div>
        <div class="chest-num">
          {{item.num}}个宝物
        </div>
      </div>
    </div>
    <div class="box-tip">
      {{cptTip}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: [
        {
          // eslint-disable-next-line sonarjs/no-duplicate-string
          ico: 'ico-chest-gold',
          num: 10
        },
        {
          ico: 'ico-chest-gold',
          num: 15
        },
        {
          ico: 'ico-chest-gold',
          num: 20
        }
      ]
    }
  },
  computed: {
    cptTip() {
      const next = this.list.findIndex(item => this.count < item.num)
      return `已找到${this.count}个宝物` +
        (next === -1 ? '' : `，再找${this.list[next].num - this.count}个可以开奖`)
    }
  },
  methods: {
    tapReceive(index) {
      this.$emit('receive', index + 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-progress {
  text-align: center;
  .box-chests {
    position: relative;
    margin: auto;
    display: flex;
    justify-content: space-between;
    width: 524px;
    .line {
      margin-top: -14px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 475px;
      height: 30px;
      background: #ffd961;
      border: 3px solid #b98219;
      z-index: -1;
    }
    .item {
      font-size: 24px;
      font-weight: bold;
      color: #ffffff;
      text-shadow: 0 -2px 0 #872c0c, 2px 0 0 #872c0c, 0 2px 0 #872c0c,
        -2px 0 0 #872c0c;
      &:nth-child(3) {
        text-shadow: 0 -2px 0 #0b397c, 2px 0 0 #0b397c, 0 2px 0 #0b397c,
          -2px 0 0 #0b397c;
      }
      .ico {
        &.disabled {
          pointer-events: none;
        }
      }
      .ico-redenvelope {
        width: 100px;
        height: 100px;
        background-image: url("~@/assets/ico/ico-redenvelope.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        &.disabled {
          background-image: url("~@/assets/ico/ico-redenvelope-disabled.png");
        }
      }
      .ico-chest-blue {
        width: 100px;
        height: 100px;
        background-image: url("~@/assets/ico/ico-chest-blue.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        &.disabled {
          background-image: url("~@/assets/ico/ico-chest-blue-disabled.png");
        }
      }
      .ico-chest-gold {
        width: 100px;
        height: 100px;
        background-image: url("~@/assets/ico/ico-chest-gold.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        &.disabled {
          background-image: url("~@/assets/ico/ico-chest-gold-disabled.png");
        }
      }
    }
  }
  .box-tip {
    display: inline-block;
    padding: 10px 14px;
    background: #f57906;
    border: 3px solid #882104;
    border-radius: 10px;
    font-size: 28px;
    color: #ffffff;
  }
}
</style>